import { isValidDate } from '@/lib/helpers'
import type { AccommodationFormData } from '@/pages/accommodation/types'

import { getLengthOfStay } from './helpers'

import type { UseFormReturn } from 'react-hook-form'

export const useLengthOfStay = ({
  getValues,
  clearErrors,
  setValue,
  watch,
}: UseFormReturn<AccommodationFormData>) => {
  const onChangeLengthOfStay = () => {
    const lengthOfStayDays = getValues('lengthOfStay.days') - 1 // 1 day means you check out on the same day
    const checkIn = getValues('lengthOfStay.checkIn')

    if (lengthOfStayDays > 0) {
      clearErrors('lengthOfStay')
    }
    if (isValidDate(checkIn) && lengthOfStayDays > 0) {
      const newCheckout = new Date(checkIn)
      newCheckout.setDate(newCheckout.getDate() + lengthOfStayDays)
      setValue('lengthOfStay.checkOut', newCheckout)
    } else {
      setValue('lengthOfStay.checkOut', null)
    }
  }

  const onChangeDate = () => {
    const start = new Date(watch('lengthOfStay.checkIn'))
    const end = new Date(watch('lengthOfStay.checkOut'))

    const { days, nights } = getLengthOfStay({
      checkIn: start,
      checkOut: end,
    })
    clearErrors('lengthOfStay')
    setValue('lengthOfStay.days', Math.max(days, 0))
    setValue('lengthOfStay.nights', Math.max(nights, 0))
  }

  return { onChangeLengthOfStay, onChangeDate }
}
